module.exports = __webpack_public_path__ + "static/media/app-devices-mobile-esp.83228065.png";